<template>
  <div class="my-4 bg-white">
    <Filtro v-model="filtro" size="lg" placeholder="">
      <template #endbuttons>
        <b-button
          size="sm"
          variant="primary"
          v-b-tooltip.hover
          title="Expandir/Recolher todos"
          @click="collapsedall = !collapsedall"
        >
          <b-icon-chevron-up v-if="collapsedall"></b-icon-chevron-up>
          <b-icon-chevron-down v-else></b-icon-chevron-down>
        </b-button>
      </template>
    </Filtro>
    <br />
    <b-alert variant="warning" :show="menusguard.length == 0 && filtro !== ''"
      >Não foi possível localizar o menu com o filtro
      <b>"{{ filtro }}"</b></b-alert
    >
    <div v-for="(m, i) of menusguard" :key="i" class="mt-2">
      <h2
        class="d-flex justify-content-between hoverme py-2 px-4 rounded"
        v-b-toggle="m.title"
      >
        <span>
          <b-icon
            :icon="m.icon"
            variant="danger"
            class="h1"
            style="vertical-align: middle !important"
          ></b-icon
          >&nbsp;&nbsp;
          <span style="color: #595959">{{ $t(m.title) }}</span>
        </span>
        <span style="vertical-align: middle !important">
          <b-icon-chevron-up
            v-if="collapsedcards[i].collapsed"
          ></b-icon-chevron-up>
          <b-icon-chevron-down v-else></b-icon-chevron-down>
        </span>
      </h2>
      <hr />
      <b-collapse
        :id="m.title"
        class="mt-2"
        v-model="collapsedcards[i].collapsed"
      >
        <b-row class="menucard-row">
          <b-col
            v-for="(s, z) of m.submenu.filter((f) =>
              f.title.toUpperCase().includes(filtro.toUpperCase())
            )"
            :key="z"
          >
            <Dashcard
              :icon="s.icon"
              :tooltip="s.hint"
              :value="$t(s.title.toString())"
              class="menucard vermelhogradiente"
              @click="onCardClick(s)"
            />
            <!-- <div class="card-counter">
              <b-icon :icon="s.icon"></b-icon>
              <span class="count-numbers">{{ z }}</span>
              <span class="count-name">{{ s.title }}</span>
            </div> -->
          </b-col>
        </b-row>
      </b-collapse>
      <!-- <b-card-group deck class="my-4">
          <b-card v-for="(s, z) of m.submenu" :key="z">
            <b-icon :icon="s.icon"></b-icon>
  
            <b-card-text> {{ s.title }} </b-card-text>
          </b-card>
        </b-card-group> -->
    </div>
    <!-- 
      collapsedcards: {{ collapsedcards }}<br />
      menuscollapsed: {{ menuscollapsed }}<br />
      menusguard: {{ menusguard }}<br/>
    -->
  </div>
</template>

<script>
import Dashcard from "./Dashcard.vue";
import Filtro from "./Filtro.vue";
import { mapGetters } from "vuex";

export default {
  name: "MenuCard",

  components: {
    Dashcard,
    Filtro,
  },

  data() {
    return {
      filtro: "",
      collapsedcards: [],
      collapsedall: true,
      menus: [
        {
          title: "Home",
          icon: "house",
          route: "/",
          roles: [],
          rolesdeny: [],
          collapsed: false,
        },
        {
          title: "Planejados",
          icon: "rulers",
          route: "/planejadosdashboard",
          roles: ["FRANQUIASROLE", "BARTZENROLE"],
          rolesdeny: [],
          collapsed: false,
          submenu: [
            {
              title: "Consumidores",
              icon: "people",
              route: "/planejadosconsumidores",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Consumidor",
                icon: "plus",
                route: "/planejadosconsumidoresfrm",
              },
            },
            {
              title: "Contratos",
              icon: "pen",
              route: "/planejadoscontratos",
              roles: ["FRANQUIASROLE"],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Contrato",
                icon: "plus",
                route: "/planejadoscontratosfrm",
              },
            },
            {
              title: "Orçamentos",
              icon: "wallet2",
              route: "/orcamentosbuilderlst",
              roles: ["FRANQUIASROLE", "BARTZENROLE"],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Orçamento",
                icon: "plus",
                route: "/orcamentosbuilderfrm",
              },
            },
          ],
        },
        {
          title: "Cadastros",
          icon: "inboxes",
          route: "/lancamentos",
          roles: ["BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          collapsed: false,
          submenu: [
            {
              title: "Consumidor",
              icon: "person-plus",
              route: "/planejadosconsumidoresfrm",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Contrato",
              icon: "pen",
              route: "/planejadoscontratosfrm",
              roles: ["FRANQUIASROLE"],
              rolesdeny: [],
            },
            {
              title: "Orçamento",
              icon: "wallet2",
              route: "/orcamentosbuilderfrm",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Logística",
          icon: "truck",
          route: "/logistica",
          roles: ["TRANSPORTADORASROLE", "BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          collapsed: false,
          submenu: [
            {
              title: "Romaneios",
              icon: "ui-checks",
              route: "/Romaneios",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Conferências de Notas",
              icon: "printer",
              route: "/notasfiscais?coletar=true",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Financeiro",
          icon: "currency-dollar",
          roles: ["BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          collapsed: false,
          submenu: [
            {
              title: "Notas Fiscais",
              icon: "printer",
              route: "/notasfiscais",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Pedidos",
              icon: "cash-coin",
              route: "/clientespedidos",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Dashboard Pedidos",
                icon: "columns-gap",
                route: "/clientesdashboardstatus",
              },
            },
            {
              title: "Depósitos",
              icon: "bank2",
              route: "/depositos",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Dashboard Depósitos",
                icon: "columns-gap",
                route: "/depositosdashboard",
              },
            },
          ],
        },
        {
          title: "Colaboradores",
          icon: "person-badge",
          route: "/despesas",
          roles: ["K1ERPROLE"],
          rolesdeny: [],
          collapsed: false,
        },
        {
          title: "Produção",
          icon: "tools",
          route: "/producao",
          roles: ["K1ERPROLE"],
          rolesdeny: [],
          collapsed: false,
          submenu: [
            {
              title: "Lotes",
              icon: "box-seam",
              route: "/lotes",
              roles: ["K1ERPROLE"],
              rolesdeny: [],
            },
          ],
        },
        /*
        {
          title: "Consultas",
          icon: "search",
          roles: ["FRANQUIASROLE", "BARTZENROLE"],
          rolesdeny: [],
          collapsed: false,
          submenu: [
            {
              title: "Metas",
              icon: "pie-chart", //bar-chart-line
              route: "/metaslojistas",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        */
        {
          title: "Relatórios",
          icon: "journal-text",
          roles: ["FRANQUIASROLE", "BARTZENROLE"],
          rolesdeny: [],
          collapsed: false,
          submenu: [
            {
              title: "Metas",
              icon: "pie-chart",
              route: "/metaslojistas",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Consultas",
              icon: "search",
              route: "/consultas",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Fornecedores/Transportadores/Clientes",
          icon: "box-seam",
          route: "/fornecedores",
          roles: ["FORNECFORMULARIOSAVALIACAOROLE"],
          rolesdeny: [],
          collapsed: false,
          submenu: [
            {
              title: "Dashboard",
              icon: "columns-gap",
              route: "/fornecedores",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Pré-Cadastro",
              icon: "box-seam",
              route: "/comprasfornecprecadastro",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["gtxisLogged"]),
    ...mapGetters("profilerStore", ["gtxProfilerRoles"]),
    menuscollapsed() {
      return this.menus.map((m) => ({
        title: m.title,
        collapsed: m.collapsed,
      }));
    },
    menusguard() {
      return this.menus
        .filter((m) => this.filtrorole(m))
        .map((m) => {
          return {
            ...m,
            ...{ collapsed: m.collapsed },
            ...{
              keywords: [m.title, ...(m.submenu || []).map((s) => s.title)],
            },
            ...{
              submenu: m.submenu
                ? m.submenu.filter((s) => this.filtrorole(s))
                : [],
            },
          };
        })
        .filter(
          (f) =>
            f.title !== "Home" &&
            (this.filtro == "" ||
              f.keywords
                .join(",")
                .toUpperCase()
                .includes(this.filtro.toUpperCase()))
        );
    },
  },

  beforeMount() {
    this.collapsedcards = this.menus.map((m, i) => ({
      title: m.title,
      index: i,
      collapsed: m.collapsed || false,
    }));
    //
    this.$api.getlocalDB(this).then((doc) => {
      if (doc) {
        this.collapsedcards.map((c) => {
          const d = doc.data.collapsedcards.find((f) => f.title == c.title);
          if (d) {
            c.collapsed = d.collapsed;
          }
        });
      }
    });
  },

  methods: {
    filtrorole(m) {
      return this.gtxProfilerRoles.length > 0
        ? m.roles.length == 0 ||
            m.roles.some(
              (role) =>
                this.gtxProfilerRoles.some((r) => r.Role === role) &&
                !m.rolesdeny.some((role) =>
                  this.gtxProfilerRoles.some((r) => r.Role === role)
                )
            )
        : true;
    },
    filtromenus() {
      return this.menusguard;
      // .filter(
      //   (f) =>
      //     f.title.toUpperCase().includes(this.filtro.toUpperCase()) ||
      //     this.filtro == ""
      // );
    },
    onCardClick(event) {
      // console.log("DepositosDashBoard.onCardClick:", event);
      this.$router.push({ path: `${event.route}` });
    },
  },

  watch: {
    collapsedall(value) {
      this.collapsedcards.map((m) => (m.collapsed = value));
    },
    collapsedcards: {
      deep: true,
      handler() {
        this.$api.setlocalDB(this);
      },
    },
  },
};
</script>

<style scoped>
.hoverme:hover {
  background-color: mistyrose;
}
.menucard {
  min-height: 150px;
}
.menucard-row {
  margin: 0 50px 0 50px;
}
@media only screen and (max-width: 600px) {
  .menucard-row {
    margin: 0 10px 0 10px;
  }
}

.card-counter {
  box-shadow: 2px 2px 10px #dadada;
  margin: 5px;
  padding: 20px 10px;
  background-color: #fff;
  height: 100px;
  border-radius: 5px;
  transition: 0.3s linear all;
}

.card-counter:hover {
  box-shadow: 4px 4px 20px #dadada;
  transition: 0.3s linear all;
}

.card-counter.primary {
  background-color: #007bff;
  color: #fff;
}

.card-counter.danger {
  background-color: #ef5350;
  color: #fff;
}

.card-counter.success {
  background-color: #66bb6a;
  color: #fff;
}

.card-counter.info {
  background-color: #26c6da;
  color: #fff;
}

.card-counter i {
  font-size: 5em;
  opacity: 0.2;
}

.card-counter .count-numbers {
  position: absolute;
  right: 35px;
  top: 20px;
  font-size: 32px;
  display: block;
}

.card-counter .count-name {
  position: absolute;
  right: 35px;
  top: 65px;
  font-style: italic;
  text-transform: capitalize;
  opacity: 0.5;
  display: block;
  font-size: 18px;
}
</style>
